import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "./dialog";
import { Button } from "./button";
import { AlertTriangle, HelpCircle, Loader2 } from "lucide-react";
import { cn } from "../../lib/utils";

/**
 * Adequado ao Design System Juri Capital:
 * - Radius: 2px (rounded-pr)
 * - Typography: Geist (sans) / JetBrains Mono (num/mono)
 * - Shadows: Apenas em overlays
 * - Colors: Semantic tokens (status-info, status-error, etc)
 */
export function ConfirmDialog({
  isOpen,
  onOpenChange,
  title,
  description,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  onConfirm,
  variant = "primary",
  isLoading = false,
  icon = "help",
}) {
  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    }
  };

  const isWarning = icon === "warning" || variant === "destructive";
  const Icon = isWarning ? AlertTriangle : HelpCircle;
  
  // DS Tokens
  const iconColor = isWarning ? "text-status-error" : "text-status-info";
  const iconBg = isWarning ? "bg-status-error-bg" : "bg-status-info-bg";

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[400px] p-0 overflow-hidden border border-border rounded-pr shadow-xl">
        <div className="p-8">
          <div className="flex flex-col items-center text-center gap-5">
            <div className={cn("p-4 rounded-full", iconBg, iconColor)}>
              <Icon className="h-7 w-7" strokeWidth={1.5} />
            </div>
            
            <div className="space-y-2">
              <DialogTitle className="text-xl font-semibold tracking-tight text-foreground">
                {title}
              </DialogTitle>
              <DialogDescription className="text-sm text-muted-foreground px-2 leading-relaxed">
                {description}
              </DialogDescription>
            </div>
          </div>
        </div>

        <DialogFooter className="bg-muted/30 p-4 mt-0 sm:flex-row gap-2 border-t border-border">
          <Button
            variant="secondary"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
            className="flex-1 sm:flex-none h-10 rounded-pr border-slate-200"
          >
            {cancelText}
          </Button>
          <Button
            variant={variant === "destructive" ? "destructive" : "primary"}
            onClick={handleConfirm}
            disabled={isLoading}
            className="flex-1 sm:flex-none h-10 min-w-[120px] rounded-pr font-semibold"
          >
            {isLoading ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              confirmText
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
